import emailjs from "@emailjs/browser";

const SERVICE_ID  = process.env.REACT_APP_EMAILJS_SERVICE_ID || "";
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "";
const PUBLIC_KEY  = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "";
const TO_EMAIL    = process.env.REACT_APP_CONTACT_TO || "info@keneteknoloji.com";

export function envOk() {
  return Boolean(SERVICE_ID && TEMPLATE_ID && PUBLIC_KEY);
}

export function getEnvDebug() {
  return {
    SERVICE_ID_OK:  !!SERVICE_ID,
    TEMPLATE_ID_OK: !!TEMPLATE_ID,
    PUBLIC_KEY_OK:  !!PUBLIC_KEY,
    TO_EMAIL: TO_EMAIL || "(boş)",
  };
}

try {
  if (PUBLIC_KEY) {
    emailjs.init({ publicKey: PUBLIC_KEY });
  }
} catch (e) {
  console.warn("[email] emailjs.init hatası:", e);
}

export async function sendContactMail({
  name,
  email,
  message,
  title = "Contact",
}) {
  const params = {
    title,
    name,
    email,
    message,
    time: new Date().toLocaleString("tr-TR"),
    from_name:  name,
    from_email: email,
    reply_to:   email,
    to_email:   TO_EMAIL,
  };

  return emailjs.send(SERVICE_ID, TEMPLATE_ID, params);
}